import { Box } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { StyledClientFilterItem } from "views/Tasks/styles";
import ClientEproceedingFya from "./clientEProceedingFYA ";
import ClientEproceedingFyi from "./clientEProceedingFYI";

const ClientProceeding = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const defaultTab = searchParams.get("tab") || "FYA";
  const [active, setActive] = useState(defaultTab);

  useEffect(() => {
    setActive(defaultTab);
  }, [defaultTab]);

  const handleTabChange = (tab: string) => {
    setActive(tab);
    setSearchParams({ tab });
  };

  return (
    <Box mt={0} pt={0}>
      <Box
        pl={2}
        pr={2}
        mb={0}
        mt={0}
        pt={0}
        pb={0}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Box display="flex" gap="15px" flexWrap="wrap" alignItems="center">
          <StyledClientFilterItem
            variant="body1"
            color="rgba(0,0,0,0.7)"
            active={active === "FYA" ? 1 : 0}
            onClick={() => handleTabChange("FYA")}
          >
            For Your Action
          </StyledClientFilterItem>
          <StyledClientFilterItem
            variant="body1"
            color="rgba(0,0,0,0.7)"
            active={active === "FYI" ? 1 : 0}
            onClick={() => handleTabChange("FYI")}
          >
            For Your Information
          </StyledClientFilterItem>
        </Box>
      </Box>
      {active === "FYA" && <ClientEproceedingFya tab="FYA" />}
      {active === "FYI" && <ClientEproceedingFyi tab="FYI" />}
    </Box>
  );
};

export default ClientProceeding;
